var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import services from 'services';
import { Diagnose, FollowUp, MedicalTest, Prescription, } from 'constants/resources';
var DRAWER_WAIT_MS = 2500;
var SECTION_WAIT_MS = 2000;
var NAVIGATION_DELAY_MS = 350;
var clickElement = function (selector) {
    var _a;
    (_a = document.querySelector(selector)) === null || _a === void 0 ? void 0 : _a.click();
};
export var openPatientLogDrawer = function () {
    clickElement('[data-onboarding="appointment-patient-log-button"]');
};
var isPatientLogDrawerOpen = function () {
    return !!document.querySelector('.patient-log-drawer.ant-drawer-open') ||
        !!document.querySelector('[data-onboarding="patient-log-entities"]') ||
        !!document.querySelector('[data-onboarding="patient-log-back"]');
};
var goToPatientLogEntities = function () {
    clickElement('[data-onboarding="patient-log-back"]');
};
export var ensurePatientLogMenuVisible = function () {
    if (!isPatientLogDrawerOpen()) {
        openPatientLogDrawer();
        return;
    }
    goToPatientLogEntities();
};
var openPatientLogSectionLink = function (linkSelector) {
    window.setTimeout(function () { return clickElement(linkSelector); }, NAVIGATION_DELAY_MS);
};
var getPatientLogSections = function () {
    var permissionService = services.permissionService;
    return [
        {
            stepKey: 'prescriptions',
            linkSelector: '[data-onboarding="patient-log-prescriptions-link"]',
            sectionSelector: '[data-onboarding="patient-log-prescriptions-section"]',
            isAvailable: function () { return permissionService.hasPermissionToIndex(Prescription); },
        },
        {
            stepKey: 'diagnoses',
            linkSelector: '[data-onboarding="patient-log-diagnoses-link"]',
            sectionSelector: '[data-onboarding="patient-log-diagnoses-section"]',
            isAvailable: function () { return permissionService.hasPermissionToIndex(Diagnose); },
        },
        {
            stepKey: 'followUps',
            linkSelector: '[data-onboarding="patient-log-follow-ups-link"]',
            sectionSelector: '[data-onboarding="patient-log-follow-ups-section"]',
            isAvailable: function () { return permissionService.hasPermissionToIndex(FollowUp); },
        },
        {
            stepKey: 'medicalTests',
            linkSelector: '[data-onboarding="patient-log-medical-tests-link"]',
            sectionSelector: '[data-onboarding="patient-log-medical-tests-section"]',
            isAvailable: function () { return permissionService.hasPermissionToIndex(MedicalTest); },
        },
        {
            stepKey: 'patientDetails',
            linkSelector: '[data-onboarding="patient-log-patient-details-link"]',
            sectionSelector: '[data-onboarding="patient-log-patient-details-section"]',
            isAvailable: function () { return true; },
        },
    ].filter(function (section) { return section.isAvailable(); });
};
var buildPatientLogSectionSteps = function (t) {
    var steps = [];
    getPatientLogSections().forEach(function (section) {
        steps.push({
            popover: {
                title: t("patientLog.steps.".concat(section.stepKey, ".title")),
                description: t('patientLog.steps.openSection'),
            },
            onHighlightStarted: ensurePatientLogMenuVisible,
        });
        steps.push({
            element: section.linkSelector,
            waitForElement: SECTION_WAIT_MS,
            onHighlighted: function () { return openPatientLogSectionLink(section.linkSelector); },
            popover: {
                title: t("patientLog.steps.".concat(section.stepKey, ".title")),
                description: t('patientLog.steps.openSection'),
            },
        });
        steps.push({
            element: section.sectionSelector,
            waitForElement: SECTION_WAIT_MS,
            popover: {
                title: t("patientLog.steps.".concat(section.stepKey, ".title")),
                description: t("patientLog.steps.".concat(section.stepKey, ".description")),
            },
        });
    });
    return steps;
};
export var buildPatientLogTourSteps = function (t) { return __spreadArray([
    {
        element: '[data-onboarding="appointment-patient-log-button"]',
        onHighlighted: openPatientLogDrawer,
        popover: {
            title: t('patientLog.steps.button.title'),
            description: t('patientLog.steps.button.description'),
        },
    },
    {
        element: '[data-onboarding="patient-log-entities"]',
        waitForElement: DRAWER_WAIT_MS,
        popover: {
            title: t('patientLog.steps.entities.title'),
            description: t('patientLog.steps.entities.description'),
        },
    }
], buildPatientLogSectionSteps(t), true); };
